import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore.js';

export default function VerifyPhone() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { saveSession } = useAuthStore();

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendMsg, setResendMsg] = useState('');
  const [cooldown, setCooldown] = useState(0);

  const userId = state?.userId;
  const phone = state?.phone;

  useEffect(() => {
    if (!userId) navigate('/register', { replace: true });
  }, [userId]);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setInterval(() => setCooldown(c => c - 1), 1000);
    return () => clearInterval(t);
  }, [cooldown]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (code.length !== 6) return setError('El código debe tener 6 dígitos');
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/phone-verify/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, code }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Código incorrecto');
      saveSession(data.token, { id: data.userId, name: data.name, email: data.email, role: data.role });
      navigate('/client', { replace: true });
    } catch {
      setError('Error de conexión. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  }

  async function handleResend() {
    setResendMsg('');
    setError('');
    setResending(true);
    try {
      const res = await fetch('/api/auth/phone-verify/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'No se pudo reenviar');
      setResendMsg('Código reenviado por WhatsApp');
      setCooldown(60);
    } catch {
      setError('Error al reenviar. Intenta más tarde.');
    } finally {
      setResending(false);
    }
  }

  return (
    <div className="auth-layout">
      <form onSubmit={handleSubmit} className="auth-card">
        <div className="auth-brand">
          <img src="/logo.png" alt="Autonation" className="auth-logo auth-logo-xl" onError={e => { e.target.style.display = 'none'; }} />
          <div className="auth-brand-sub">Verificar teléfono</div>
        </div>

        <p style={{ color: 'var(--silver-light,#cbd5e1)', textAlign: 'center', margin: '0 0 1.5rem' }}>
          Enviamos un código de 6 dígitos a<br />
          <strong style={{ color: '#fff' }}>{phone || 'tu teléfono'}</strong>
        </p>

        <div className="form-group">
          <label className="form-label">Código de verificación</label>
          <input
            className="form-input"
            placeholder="000000"
            maxLength={6}
            inputMode="numeric"
            pattern="[0-9]{6}"
            value={code}
            onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            autoFocus
            required
            style={{ letterSpacing: '0.3em', fontSize: '1.4rem', textAlign: 'center' }}
          />
        </div>

        {error && <div className="error-text">{error}</div>}
        {resendMsg && <div style={{ color: '#4ade80', fontSize: '0.85rem', textAlign: 'center' }}>{resendMsg}</div>}

        <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: '1rem' }}>
          {loading ? 'Verificando…' : 'Confirmar código →'}
        </button>

        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate('/register', { replace: true })}
          disabled={loading}
          style={{ marginTop: '0.5rem' }}
        >
          ← Volver y modificar datos
        </button>

        <div className="hint-text" style={{ marginTop: '1rem', textAlign: 'center' }}>
          {cooldown > 0
            ? `Reenviar en ${cooldown}s`
            : (
              <button type="button" className="link" onClick={handleResend} disabled={resending}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                {resending ? 'Reenviando…' : '¿No recibiste el código? Reenviar'}
              </button>
            )
          }
        </div>
      </form>
    </div>
  );
}
